import { Compass } from 'lucide-react';
import { Link } from 'react-router';

import { EstadoVazio } from '@/ui/components/estado-vazio';
import { estiloBotao } from '@/ui/primitives/estilos';

export function PaginaNaoEncontrada() {
  return (
    <EstadoVazio
      icone={<Compass />}
      titulo="Esta página não existe"
      texto="O endereço pode ter mudado. Volte ao início e siga pelo menu."
      acao={
        <Link to="/" className={estiloBotao({ variante: 'primario' })}>
          Ir para o início
        </Link>
      }
    />
  );
}
